import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarService } from 'src/app/services/calendar.service';
import { OptionSet } from 'src/app/models/OptionSet';

@Component({
  selector: 'app-add-class-schedule-dialog',
  templateUrl: './add-class-schedule-dialog.component.html',
  styleUrls: ['./add-class-schedule-dialog.component.scss']
})
export class AddClassScheduleDialogComponent {
  form: FormGroup;

  classes: Array<OptionSet> = [];
  classNumbers: Array<OptionSet> = [];
  supportTypes: Array<OptionSet> = [];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddClassScheduleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public calendarSvc: CalendarService
  ) {
    this.classes = this.calendarSvc.ClassesList;
    this.classNumbers = this.calendarSvc.ClassCodesList;
    this.supportTypes = this.calendarSvc.ClassificationList;

    this.form = this.fb.group({
      class: [null, Validators.required],
      classNumber: [null],
      supportType: [null]
    });
  }
  loading: boolean = false;

  save() {
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    this.calendarSvc.spinnerSubjectEmit(true);

    const classScheduleData = {
      Class: this.form.value.class,
      ClassCode: this.form.value.classNumber,
      Classification: this.form.value.supportType
    };

    this.calendarSvc.addClassSchedule(classScheduleData).then((res: any) => {
      this.loading = false;
      this.calendarSvc.spinnerSubjectEmit(false);

      if (!this.calendarSvc.dataService.IsError(res)) {
        this.dialogRef.close(true);
      } else {
        alert("ארעה שגיאה בשמירת מערכת השעות");
      }
    }).catch(error => {
      this.loading = false;
      this.calendarSvc.spinnerSubjectEmit(false);
      alert("ארעה שגיאה");
    });
  }
}